<template>
  <div class="selector">
    <div class="label" >{{ currentLabel }}: &nbsp;</div>
    <div class="activator" @click="onActivatorClick">
      {{ selectedValue }}
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount, ref } from '@vue/composition-api';
import { useStore } from '@vue3shims';
export default {
  setup(props, { emit }) {
    const store = useStore();


    const allLabel = computed(() => {
      switch(props.tab) {
        case 'parentGroup':
          return 'All Parent Groups';
        case 'group':
          return 'All Groups';
        case 'subGroup':
          return 'All SubGroups';
      }
    })
    const currentLabel = ref(props.label);
    const selectedValue = computed(() => {
      let item = store.getters[`groupSelector/${props.tab}`];
      // console.log(`item`, item);
      if(item) {
        return item[`${props.tab}Name`];
      }
      return allLabel.value;
    });
    const onActivatorClick = () => {
      emit('activate-tab', props.tab);
    }

    // onBeforeMount(() => {
    // });

    return {
      currentLabel,
      onActivatorClick,
      selectedValue,
    }
  },
  emits: ['activate-tab'],
  props: {
    tab: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: () => '',
    }
  }
}
</script>

<style lang="scss" scoped>
.selector {
  background-color: $leaf;
  color: $white;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-evenly;
  margin-left: 2rem;
  font-size: 0.85714rem;
  padding-right: 5px;

  .activator {
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }

}
</style>